import WindowStepper from './WindowStepper.vue';

export default WindowStepper;
